"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageHeaderButton = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _button = require("../../button");

var _context = require("../../context");

var _propTypes = require("../../prop-types");

var _utils = require("../../utils");

var _PageHeaderContext = require("./PageHeaderContext");

var _constants = require("./constants");

var _interfaces = require("./interfaces");

var _core = require("@emotion/core");

var _excluded = ["paddingHorizontal", "children"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var PageHeaderButtonBase = (0, _context.styledWithTheme)(_button.Button)(function (_ref) {
  var hasHover = _ref.hasHover,
      paddingHorizontal = _ref.paddingHorizontal,
      pageHeaderColorScheme = _ref.pageHeaderColorScheme,
      disabled = _ref.disabled,
      selectors = _ref.theme.selectors;
  var isInverted = pageHeaderColorScheme === _interfaces.PageHeaderColorScheme.Inverted;
  var color = selectors.color(isInverted ? 'neutral90' : 'neutral0');
  var hoverStyles = hasHover ? {
    ':hover': {
      backgroundColor: selectors.color(isInverted ? 'primary30' : 'primary60'),
      borderColor: color
    }
  } : {};
  return _objectSpread(_objectSpread({
    borderRadius: 0,
    color: color,
    padding: "0 ".concat((0, _utils.px)(selectors.space(paddingHorizontal) || paddingHorizontal)),
    height: '100%',
    fontWeight: selectors.fontWeight('regular'),
    transition: 'none',
    ':focus:before': {
      borderColor: 'transparent',
      borderRadius: 0,
      transition: 'none'
    },
    ':focus,:visited,:active': {
      borderColor: color
    }
  }, disabled && {
    backgroundColor: selectors.color(isInverted ? 'neutral0' : 'neutral90'),
    color: selectors.color('neutral50')
  }), hoverStyles);
});
var PageHeaderButtonWithoutDocs = /*#__PURE__*/(0, _react.forwardRef)(function (_ref2, ref) {
  var _ref2$paddingHorizont = _ref2.paddingHorizontal,
      paddingHorizontal = _ref2$paddingHorizont === void 0 ? _constants.PageHeaderButtonDefaultProps.paddingHorizontal : _ref2$paddingHorizont,
      children = _ref2.children,
      forwardedProps = (0, _objectWithoutProperties2.default)(_ref2, _excluded);

  var _useContext = (0, _react.useContext)(_PageHeaderContext.PageHeaderContext),
      colorScheme = _useContext.colorScheme;

  return (0, _core.jsx)(PageHeaderButtonBase, (0, _extends2.default)({
    colorScheme: _button.ButtonColorScheme.DarkBackground,
    paddingHorizontal: paddingHorizontal,
    pageHeaderColorScheme: colorScheme,
    shouldUseResponsiveContent: false,
    variant: _button.ButtonVariant.Tertiary
  }, forwardedProps, {
    ref: ref
  }), children);
});
var PageHeaderButtonWithDocs = (0, _stencilReactDesc.describe)(PageHeaderButtonWithoutDocs).description('Button for page header.');
PageHeaderButtonWithDocs.defaultProps = _objectSpread({}, _constants.PageHeaderButtonDefaultProps);
PageHeaderButtonWithDocs.propTypes = {
  paddingHorizontal: (0, _propTypes.cssValue)().description('Sets the horizontal (left and right) padding.'),
  icon: _stencilReactDesc.PropTypes.node.description('Adds an icon to the left side of the button.'),
  children: _stencilReactDesc.PropTypes.node.description('Content of the button.')
};
var PageHeaderButton = (0, _utils.withTestAttributes)({
  component: 'StencilReactPageHeaderButton'
})(PageHeaderButtonWithDocs);
exports.PageHeaderButton = PageHeaderButton;
PageHeaderButton.displayName = 'PageHeaderButton';